<div class="role-permissions-detail">
  <ui-page-header
    [title]="role?.name || ('settings.role' | translate)"
    [titleTag]="roleTypeTag"
    [titleTagType]="roleTypeTagType"
    [showBackButton]="true"
    [breadcrumbs]="breadcrumbs">
    <ui-button
      type="primary"
      icon="check_icon"
      [isLoading]="isSaving"
      [disabled]="!role || role.is_protected || isSaving"
      [label]="('common.save' | translate | uppercase)"
      (click)="saveChanges()">
    </ui-button>
  </ui-page-header>

  <div class="role-permissions-detail__card">
    <div class="role-permissions-detail__tabs">
      <div
        role="button"
        class="role-permissions-detail__tab"
        [class.role-permissions-detail__tab--active]="activeTab === 'permissions'"
        (click)="activeTab = 'permissions'">
        {{ 'settings.feature_access' | translate }}
      </div>
      <div
        role="button"
        class="role-permissions-detail__tab"
        [class.role-permissions-detail__tab--active]="activeTab === 'fieldVisibility'"
        (click)="activeTab = 'fieldVisibility'">
        {{ 'settings.field_visibility' | translate }}
      </div>
    </div>

    <div class="role-permissions-detail__card-content" *ngIf="activeTab === 'permissions'">
      <div class="role-permissions-detail__empty" *ngIf="!permissionCatalog.length">
        {{ 'settings.no_permissions_available' | translate }}
      </div>

      <table class="role-permissions-detail__permissions-table" *ngIf="permissionCatalog.length">
        <thead>
          <tr>
            <th>{{ 'settings.features' | translate }}</th>
            <th>{{ 'settings.access' | translate }}</th>
            <th>{{ 'settings.data_scope' | translate }}</th>
            <th>{{ 'common.actions' | translate }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let module of permissionCatalog; trackBy: trackByModuleId">
            <tr
              class="role-permissions-detail__module-row"
              [class.role-permissions-detail__module-row--expanded]="isModuleExpanded(module)"
              [class.role-permissions-detail__module-row--has-actions]="module.actionPermissions.length"
              (click)="toggleModuleExpanded(module)">
              <td>
                <div class="role-permissions-detail__feature-cell">
                  <span class="role-permissions-detail__feature-name">{{ getModuleLabel(module) }}</span>
                </div>
              </td>
              <td>
                <label
                  class="role-permissions-detail__switch"
                  [class.role-permissions-detail__switch--disabled]="role?.is_protected || !module.hasAccessToggle || !module.permissionIds.length"
                  (click)="onModuleAccessClick($event)">
                  <input
                    type="checkbox"
                    [checked]="isModuleAccessEnabled(module)"
                    [disabled]="role?.is_protected || !module.hasAccessToggle || !module.permissionIds.length"
                    (click)="onModuleAccessClick($event)"
                    (change)="onModuleAccessChanged(module, $event)"
                  />
                  <span class="role-permissions-detail__slider"></span>
                </label>
              </td>
              <td (click)="$event.stopPropagation()">
                <div
                  *ngIf="module.dataScopePermissionId !== null"
                  class="role-permissions-detail__scope-switch">
                  <button
                    type="button"
                    [class.role-permissions-detail__scope-button--active]="!isDataScopeOwn(module)"
                    [disabled]="role?.is_protected"
                    (click)="setDataScopeAll(module)">
                    {{ 'settings.data_scope_all_records' | translate }}
                  </button>
                  <button
                    type="button"
                    [class.role-permissions-detail__scope-button--active]="isDataScopeOwn(module)"
                    [disabled]="role?.is_protected"
                    (click)="setDataScopeOwn(module)">
                    {{ 'settings.data_scope_own_records' | translate }}
                  </button>
                </div>
              </td>
              <td class="role-permissions-detail__module-actions-count-cell">
                <span
                  *ngIf="shouldShowModuleActionsSummary(module)"
                  class="role-permissions-detail__actions-metric">
                  <span class="role-permissions-detail__actions-metric-actual">
                    {{ getSelectedModuleActionsCount(module) }}
                  </span>
                  <span class="role-permissions-detail__actions-metric-total">
                    /{{ module.actionPermissions.length }}
                  </span>
                </span>
              </td>
              <td class="role-permissions-detail__module-actions-cell">
                <button
                  *ngIf="isModuleAccessEnabled(module) && module.actionPermissions.length"
                  type="button"
                  class="role-permissions-detail__expand-button"
                  [disabled]="!module.actionPermissions.length"
                  (click)="toggleModuleExpanded(module); $event.stopPropagation()">
                  <mat-icon
                    class="role-permissions-detail__expand-icon"
                    [class.role-permissions-detail__expand-icon--expanded]="isModuleExpanded(module)">
                    expand_more
                  </mat-icon>
                </button>
              </td>
            </tr>
            <tr
              *ngIf="isModuleExpanded(module) && module.actionPermissions.length"
              class="role-permissions-detail__expanded-row">
              <td colspan="5">
                <div class="role-permissions-detail__expanded-content">
                  <div class="role-permissions-detail__expanded-title">
                    {{ 'settings.available_actions' | translate }}
                  </div>
                  <div class="role-permissions-detail__permission-actions-grid">
                    <label
                      *ngFor="let action of module.actionPermissions; trackBy: trackByPermissionAction"
                      class="role-permissions-detail__permission-item">
                      <span 
                        class="role-permissions-detail__switch"
                        [class.role-permissions-detail__switch--disabled]="role?.is_protected"
                      >
                        <input
                          type="checkbox"
                          [disabled]="role?.is_protected"
                          [checked]="isSelected(action.permissionId)"
                          (change)="togglePermission(module, action.permissionId)" />
                        <span class="role-permissions-detail__slider"></span>
                      </span>
                      <span>{{ getActionLabel(action.action) | uppercase }}</span>
                    </label>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <div class="role-permissions-detail__card-content" *ngIf="activeTab === 'fieldVisibility'">
      <div class="role-permissions-detail__fv-header">
        <div class="role-permissions-detail__fv-module-tabs">
          <button
            *ngFor="let mod of fieldModules"
            type="button"
            class="role-permissions-detail__fv-module-tab"
            [class.role-permissions-detail__fv-module-tab--active]="activeFieldModule === mod.key"
            (click)="setActiveFieldModule(mod.key)">
            <span>{{ mod.labelKey | translate }}</span>
            <span class="role-permissions-detail__fv-tab-count role-permissions-detail__fv-tab-count--visible">{{ countVisible(mod.key) }}</span>
            <span class="role-permissions-detail__fv-tab-count role-permissions-detail__fv-tab-count--hidden">{{ countHidden(mod.key) }}</span>
          </button>
        </div>
        <div class="role-permissions-detail__fv-bulk">
          <span class="role-permissions-detail__fv-bulk-label">{{ 'settings.field_visibility_set_all' | translate }}:</span>
          <button
            type="button"
            class="role-permissions-detail__fv-bulk-btn role-permissions-detail__fv-bulk-btn--visible"
            [disabled]="role?.is_protected"
            (click)="setAllVisible()">
            {{ 'settings.visibility_visible' | translate | uppercase }}
          </button>
          <button
            type="button"
            class="role-permissions-detail__fv-bulk-btn role-permissions-detail__fv-bulk-btn--hidden"
            [disabled]="role?.is_protected"
            (click)="setAllHidden()">
            {{ 'settings.visibility_hidden' | translate | uppercase }}
          </button>
        </div>
      </div>

      <div class="role-permissions-detail__fv-counts">
        <span class="role-permissions-detail__fv-count role-permissions-detail__fv-count--visible">{{ countVisible(activeFieldModule) }} {{ 'settings.visibility_visible' | translate }}</span>
        <span class="role-permissions-detail__fv-count role-permissions-detail__fv-count--hidden">{{ countHidden(activeFieldModule) }} {{ 'settings.visibility_hidden' | translate }}</span>
        <span class="role-permissions-detail__fv-count-total">{{ countTotal(activeFieldModule) }} {{ 'settings.field_visibility_total_fields' | translate }}</span>
      </div>

      <div class="role-permissions-detail__fv-section">
        <div class="role-permissions-detail__fv-section-header">
          <span class="role-permissions-detail__fv-section-title">{{ 'settings.field_visibility_system_fields' | translate }}</span>
          <span class="role-permissions-detail__fv-section-sub">{{ 'settings.field_visibility_system_fields_hint' | translate }}</span>
        </div>

        <table class="role-permissions-detail__fields-table">
          <thead>
            <tr>
              <th>{{ 'settings.field_visibility_field' | translate }}</th>
              <th>{{ 'settings.field_visibility_type' | translate }}</th>
              <th>{{ 'settings.visibility' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let entry of getSystemFieldsFor(activeFieldModule); trackBy: trackByFieldEntryKey">
              <td>
                <span>{{ getFieldLabel(entry) }}</span>
                <span *ngIf="entry.is_locked" class="role-permissions-detail__fv-required-pill">
                  {{ 'settings.field_visibility_required' | translate }}
                </span>
              </td>
              <td>
                <span *ngIf="entry.type" [class]="getTypeBadgeClass(entry.type)">{{ getFieldTypeLabel(entry.type) }}</span>
              </td>
              <td>
                <div class="role-permissions-detail__visibility-actions">
                  <button
                    type="button"
                    [class.role-permissions-detail__visibility-action--visible]="!isFieldHidden(activeFieldModule, entry.key)"
                    [disabled]="role?.is_protected"
                    (click)="setFieldVisibility(activeFieldModule, entry, false)">
                    {{ 'settings.visibility_visible' | translate }}
                  </button>
                  <button
                    type="button"
                    [class.role-permissions-detail__visibility-action--hidden]="isFieldHidden(activeFieldModule, entry.key)"
                    [disabled]="role?.is_protected || entry.is_locked"
                    (click)="setFieldVisibility(activeFieldModule, entry, true)">
                    {{ 'settings.visibility_hidden' | translate }}
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- <div class="role-permissions-detail__fv-section">
        <div class="role-permissions-detail__fv-section-header">
          <span class="role-permissions-detail__fv-section-title">{{ 'settings.field_visibility_custom_fields' | translate }}</span>
          <span class="role-permissions-detail__fv-section-sub">{{ 'settings.field_visibility_custom_fields_hint' | translate }}</span>
        </div>
        <div class="role-permissions-detail__fv-empty">
          {{ 'settings.field_visibility_no_custom_fields' | translate }}
        </div>
      </div> -->
    </div>
  </div>
</div>
